export default "__VITE_ASSET__BlKKV6Wn__"